<template>

  <select :value="value" @input="$emit('input', $event.target.value)">
    <option v-for="state in states" :value="state.code" :key="state.code" :title="state.name">{{ state.code }}</option>
  </select>

</template>

<script>
  import { states } from '@/constants/states'

  export default {
    data () {
      return {
        states,
      };
    },
    name: 'StatesSelect',
    props: {
      value: { type: String }
    },
  }
</script>

<style scoped>

</style>
